if (typeof window.cartTermsCheckboxInit === 'undefined') {

  window.cartTermsCheckboxInit = true;

  // Delegated listeners so it keeps working after the cart subtotal is re-rendered via AJAX
  // (scripts injected with innerHTML are not executed).
  const TERMS_SELECTOR = '.agree-to-terms input[type="checkbox"][required]';

  const getScope = (element) => element.closest('#AjaxCartSubtotal') || document;

  const termsAccepted = (scope) => {
    return Array.from(scope.querySelectorAll(TERMS_SELECTOR)).every((checkbox) => checkbox.checked);
  };

  const updateCheckoutButton = (scope) => {
    const checkoutButton = scope.querySelector('#CheckOut');
    if (checkoutButton) {
      checkoutButton.disabled = !termsAccepted(scope);
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches(TERMS_SELECTOR)) {
      updateCheckoutButton(getScope(event.target));
    }
  });

  // Safety net: block checkout if any required checkbox is unchecked, even if the button got enabled.
  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('#CheckOut');
    if (checkoutButton && !termsAccepted(getScope(checkoutButton))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter && submitter.name === 'checkout' && !termsAccepted(getScope(submitter))) {
      event.preventDefault();
    }
  }, true);

  document.querySelectorAll('#AjaxCartSubtotal').forEach(updateCheckoutButton);

}
